import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { Container, Row, Col, Visible, Hidden } from "react-grid-system";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import _Section from "./Section.js";
import { Image, MarkdownGenerator } from "./../Blocks.js";
import { Link } from "react-router-dom";

import Background from "./SectionPOD/Background.js";

import utils from "./../utils.js";

import IMG_1 from "./photos/Hohe-qualitaet1.jpg";
import IMG_1_SMALL from "./photos/Hohe-qualitaet1-small.jpg";
import IMG_2 from "./photos/Hohe-qualitaet2.jpg";
import IMG_3 from "./photos/Einfach-Bequem1.jpg";
import IMG_3_SMALL from "./photos/Einfach-Bequem1-small.jpg";
import IMG_4 from "./photos/Einfach-Bequem2.jpg";

const { mapLinear, clamp } = utils;

const Section = styled(_Section)`
  position: relative;
`;

const MarkdownStyle = css`
  p {
    font-size: 1.06em;
    font-weight: 200;
    margin-bottom: 1em;
    line-height: 1.75;
  }
`;

const MyMarkdown = MarkdownGenerator({
  style: MarkdownStyle,
  className: "body-large color-bg",
});

class SectionPOD extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  $el = React.createRef();
  state = {
    scroll: 0,
    width: 0,
  };
  onResize = debounce(() => {
    this.setState({ width: window.innerWidth });
  }, 150);
  onScroll = throttle(evt => {
    this.setState({ scroll: this.getWindowScrollY() });
  }, 150);
  getWindowScrollY() {
    return window.scrollY || window.pageYOffset;
  }
  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });
    this.onResize();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }
  render() {
    const copy = this.context.copy.get("SectionPOD");
    const p = this.state.scroll;
    const curve1 = clamp(mapLinear(p, -0.4, 0.7, 0, 1), 0, 1);
    const ty1 = -10 + 15 * curve1;
    const ty2 = 10 - 15 * curve1;

    return (
      <Section className="section-pod mt4 no-gutter mmt0" innerRef={this.$el}>
        <Hidden xs sm>
          <Background $el={this.$el.current ? this.$el.current : null} />
        </Hidden>
        <Container>
          <Row className="my2">
            <Col>&nbsp;</Col>
          </Row>
          <Row id="philosophie" className="mt3 mb4 py2 mmy0" nogutter>
            <Col md={6} className="overflow-visible">
              <Hidden xs sm>
                <Image
                  color={{ blur: 0, color: "rgba(222,242,237,1)" }}
                  transform={{ y: `${ty1}%` }}
                  imageClassName="fit"
                  src={IMG_1}
                  alt=""
                />
                <Image
                  shadow={false}
                  wrapperClassName="my3 right"
                  imageClassName="fit"
                  transform={{ x: `17.5%`, y: `${ty1}%` }}
                  width={358}
                  src={IMG_2}
                  alt=""
                />
              </Hidden>
            </Col>
            <Col md={4} offset={{ md: 2 }}>
              <h3 className="h2 line-height-4 mb3 mt4 color-tt mmt0 mmb3 font-light">
                {copy && copy.pod[0].title}
              </h3>

              <Visible xs sm>
                <Image
                  color={{ blur: 0, color: "rgba(222,242,237,1)" }}
                  shadow={true}
                  wrapperClassName="w-100 fit mb3"
                  imageClassName="w-100"
                  src={IMG_1_SMALL}
                />
              </Visible>

              <MyMarkdown>{copy && copy.pod[0].body}</MyMarkdown>
            </Col>
          </Row>
          <Row className="mt4 mb0 pt2 pb0 mmy0" nogutter>
            <Col md={4} offset={{ md: 2 }}>
              <h3 className="h2 line-height-4 mb3 mt4 color-tt mmt1 pmy1 mmb3 wm-80 font-light">
                {copy && copy.pod[1].title}
              </h3>
              <Visible xs sm>
                <Col
                  md={5}
                  offset={{ md: 2 }}
                  className="overflow-visible"
                  align="right"
                >
                  <Image
                    color={{ blur: 0, color: "rgba(255,221,206,1)" }}
                    shadow={true}
                    wrapperClassName="w-100 mb3"
                    imageClassName="w-100 fit isRight"
                    src={IMG_3_SMALL}
                    alt=""
                    style={
                      window.innerWidth < 900
                        ? { width: "calc(100% - 20px)" }
                        : {}
                    }
                  />
                </Col>
              </Visible>
              {copy ? (
                <p
                  className="body-large color-bg"
                  style={{
                    fontSize: "1.17em",
                    fontWeight: "200",
                    marginBottom: "1em",
                    lineHeight: "1.8",
                  }}
                >
                  Unser <Link to="/wizard">Online-Berater</Link> hilft dir die
                  perfekte Linse zu finden. Du kannst unsere Kontaktlinsen
                  jederzeit online bestellen und wir liefern sie beqeuem bis zu
                  dir nach Hause. Erhalte all unsere Linsen optional im Abo und
                  sichere dir einen Preisvorteil von 10% ab der zweiten
                  Lieferung, damit du dich um die wirklich wichtigen Dinge im
                  Leben kümmern kannst.
                </p>
              ) : (
                ""
              )}
            </Col>
            <Hidden xs sm>
              <Col
                md={5}
                offset={{ md: 1 }}
                className="overflow-visible"
                align="right"
              >
                <Image
                  color={{ blur: 0, color: "rgba(255,221,206,1)" }}
                  imageClassName="fit"
                  transform={{ y: `${ty2}%` }}
                  src={IMG_3}
                  alt=""
                />
                <Image
                  shadow={false}
                  wrapperClassName="my3 left"
                  imageClassName="fit"
                  transform={{ x: `-17.5%`, y: `${ty2}%` }}
                  src={IMG_4}
                  width={360}
                  alt=""
                />
              </Col>
            </Hidden>
          </Row>
        </Container>
      </Section>
    );
  }
}

export default SectionPOD;



// WEBPACK FOOTER //
// ./src/Home/SectionPOD.js